import { createHttpClient, getStoredAuthToken } from "./client";

export function createFeedbackApi(baseUrl) {
  const http = createHttpClient(baseUrl);

  return {
    submit(payload) {
      return http.post("/quark/wx/homepage/submitFeedback", {
        ...payload,
        wxLoginToken: getStoredAuthToken() || undefined,
      });
    },
  };
}
